function hasAccess(userRoles = [], permittedRoles = []) {
  if (userRoles.some((role) => permittedRoles.includes(role))) {
    return true;
  }
  return false;
}

export { hasAccess };
